/*
 * Dodatki AURY w szufladzie koszyka: kod rabatowy i dodatek do zamówienia.
 *
 * Obie rzeczy renderują się wewnątrz #CartDrawer, który Dawn podmienia
 * w całości przy każdej zmianie koszyka. Dlatego nie podpinamy nasłuchów do
 * konkretnych elementów — jeden delegowany listener na dokumencie przeżywa
 * każde przerenderowanie szuflady.
 */
(function () {
  'use strict';

  /*
   * Kod rabatowy.
   *
   * AJAX Cart API nie ma metody przypinającej kod do koszyka — kody obsługuje
   * checkout albo adres /discount/KOD, który ustawia rabat w sesji
   * i przekierowuje. Stąd przeładowanie strony: to jedyna droga dostępna
   * z poziomu theme'u, nie niedoróbka.
   */
  function applyDiscount(button) {
    var wrapper = button.closest('aura-discount');
    var input = wrapper && wrapper.querySelector('input[name=discount]');
    if (!input) return;

    var code = input.value.trim();
    if (!code) {
      input.focus();
      return;
    }

    button.disabled = true;
    var back = window.location.pathname + window.location.search;
    window.location.href =
      '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  }

  /*
   * Dodatek do zamówienia.
   *
   * Prosimy o przerenderowanie tych samych sekcji, o które prosi cart-drawer,
   * i oddajemy odpowiedź jego własnej metodzie renderContents — dzięki temu
   * szuflada odświeża się dokładnie tak samo jak po zwykłym dodaniu do
   * koszyka, razem z paskiem dostawy i licznikiem w nagłówku.
   */
  function addBump(button) {
    var drawer = document.querySelector('cart-drawer');
    var variantId = button.dataset.variantId;
    if (!variantId) return;

    button.disabled = true;

    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (drawer && data.sections) {
          drawer.renderContents(data);
        } else {
          // Bez szuflady albo bez sekcji w odpowiedzi zostaje przeładowanie —
          // lepsze niż koszyk pokazujący nieaktualny stan.
          window.location.reload();
        }
      })
      .catch(function () {
        button.disabled = false;
      });
  }

  /*
   * Puls koszyka po dodaniu produktu.
   *
   * Dawn publikuje zdarzenie 'cart-update' po każdej udanej zmianie koszyka
   * (product-form, cart-items, cart-drawer). Podpinamy się pod nie zamiast
   * pod kliknięcie przycisku — dzięki temu puls leci dopiero, gdy Shopify
   * potwierdzi dodanie, a nie gdy klient kliknie i request się wywali.
   *
   * Animujemy sam link #cart-icon-bubble, bo Section Rendering API podmienia
   * tylko jego wnętrze — element przeżywa przerenderowanie, a klasa na nim
   * nie ginie w połowie animacji.
   */
  function bumpCart() {
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart) return;

    // Reset przed ponownym odpaleniem: bez tego drugie dodanie pod rząd nie
    // animuje się wcale, bo atrybut już stoi na 'true'.
    delete cart.dataset.bump;
    void cart.offsetWidth;
    cart.dataset.bump = 'true';
    window.setTimeout(function () {
      delete cart.dataset.bump;
    }, 240);
  }

  /*
   * Podmiana wariantu etui po przekroczeniu progu.
   *
   * Etui ma dwa warianty: płatny 29,99 i progowy za grosz. Klient, który
   * najpierw dorzucił etui, a dopiero potem dobrał trzecie opakowanie, miałby
   * w koszyku wariant płatny i musiałby go ręcznie usunąć i dodać ponownie.
   * Nikt tego nie zrobi — zobaczy tylko, że obiecany grosz nie zadziałał.
   *
   * Działa w OBIE strony. Zejście poniżej progu przywraca wariant płatny,
   * inaczej etui zostawałoby za grosz bez spełnionego warunku.
   *
   * /cart/update.js przyjmuje mapę wariant->ilość, więc usunięcie starego
   * i dodanie nowego mieści się w jednym żądaniu: koszyk nie przechodzi przez
   * stan pośredni, w którym etui znika.
   */
  var swapping = false;

  function syncCaseVariant() {
    if (swapping) return;

    var el = document.querySelector('aura-case-sync');
    if (!el) return;

    var inCart = el.dataset.inCart;
    if (!inCart) return; // etui nie ma w koszyku — nie ma czego podmieniać

    var packs = parseInt(el.dataset.packs, 10) || 0;
    var min = parseInt(el.dataset.minPacks, 10) || 0;
    var wanted = packs >= min ? el.dataset.giftId : el.dataset.paidId;
    if (!wanted || wanted === inCart) return;

    swapping = true;
    var updates = {};
    updates[inCart] = 0;
    updates[wanted] = 1;

    var drawer = document.querySelector('cart-drawer');
    var body = { updates: updates };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Na stronie /cart odświeżenie szuflady nic nie daje — widoczna lista
        // pozycji to osobna sekcja, która zostałaby z nieaktualną ceną etui.
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
          return;
        }
        if (drawer && data.sections) drawer.renderContents(data);
        else window.location.reload();
      })
      .catch(function () {})
      .finally(function () {
        swapping = false;
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      bumpCart();
      syncCaseVariant();
    });
  }

  // Pierwsze wejście na stronę z gotowym koszykiem też musi się zgadzać:
  // klient mógł dodać etui, zamknąć kartę i wrócić po dobraniu opakowań.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCaseVariant);
  } else {
    syncCaseVariant();
  }

  document.addEventListener('click', function (event) {
    var discount = event.target.closest('[data-aura-discount-apply]');
    if (discount) {
      applyDiscount(discount);
      return;
    }

    var bump = event.target.closest('[data-aura-bump-add]');
    if (bump) addBump(bump);
  });

  // Enter w polu kodu ma robić to samo co przycisk. Pole nie stoi we własnym
  // <form>, bo szuflada renderuje już formularz koszyka i zagnieżdżanie
  // formularzy jest w HTML-u nielegalne.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (!event.target.matches('aura-discount input[name=discount]')) return;
    event.preventDefault();
    var button = event.target.closest('aura-discount').querySelector('[data-aura-discount-apply]');
    if (button) applyDiscount(button);
  });
})();
